// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"07ff1256","453":"258b012d","667":"da8aa047","977":"a5c2f382"}[chunkId] + ".chunk.js";
};